import { render, staticRenderFns } from "./TopBrandIcon.vue?vue&type=template&id=d95c9ab8&scoped=true&"
import script from "./TopBrandIcon.vue?vue&type=script&lang=js&"
export * from "./TopBrandIcon.vue?vue&type=script&lang=js&"
import style0 from "./TopBrandIcon.vue?vue&type=style&index=0&id=d95c9ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95c9ab8",
  null
  
)

export default component.exports